import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes';
import './styles/App.css';

// 生产部署在 /admin 子路径下(PUBLIC_URL=/admin);本地开发为空 => 根路径
const ROUTER_BASENAME = process.env.PUBLIC_URL || undefined;

const App: React.FC = () => {
  return (
    <BrowserRouter basename={ROUTER_BASENAME}>
      <AppRoutes />
    </BrowserRouter>
  );
};

export default App;

